// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase/app'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import bootstrap from 'bootstrap/scss/bootstrap.scss'

Vue.use(BootstrapVue);

Vue.config.productionTip = false

let app;
// Initialize Firebase
var config = {
  apiKey: 'AIzaSyCA7-NcFhbWrJcsLO9GnThcjo5eHCvJZJ4',
  authDomain: 'dekcom-camp.firebaseapp.com',
  databaseURL: 'https://dekcom-camp.firebaseio.com',
  projectId: 'dekcom-camp',
  storageBucket: 'dekcom-camp.appspot.com',
  messagingSenderId: '997587136758'
}
firebase.initializeApp(config)
firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      bootstrap,
      firebase,
      components: {
        App
      },
      template: '<App/>'
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js